var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');
var header = require('../layout/components/header');
var heading = require('../components/heading');
var dateFormat = 'MM/DD/YYYY';
var moment = require('moment');
var buttonElement = require('../components/button');
var downloadReportModalInterface = require('../layout/components/downloadReportModalInterface');
var paginationWithSearch = require('../data/components/paginationWithSearch');
var dragscroll = require('../libs/dragscroll');
var session = require('../auth/models/session');
var filterGroupsModal = require('../data/components/filterGroupsModal');
var groupsFilterComponent = require('./groupsFilterComponent');
var downloadCalibrationReport = require('../data/components/downloadCalibrationReport');
var calibrationBulkReport = require('./calibrationBulkReport');
var alerts = require('../layout/components/alerts');

var component = {};

function getPointRecord(assetRecord) {
  var pointEdge = assetRecord && Array.isArray(assetRecord.out_pointOf) ? assetRecord.out_pointOf[0] : null;
  return pointEdge && pointEdge.in ? pointEdge.in : null;
}

function getPointRid(assetRecord) {
  var pointRecord = getPointRecord(assetRecord);
  return pointRecord && pointRecord['@rid'] ? pointRecord['@rid'] : '';
}

function getPointName(assetRecord) {
  var pointRecord = getPointRecord(assetRecord);
  return pointRecord && pointRecord.name ? pointRecord.name : '';
}

function getPointSourceRid(assetRecord) {
  var pointRecord = getPointRecord(assetRecord);
  var sourceEdge = pointRecord && Array.isArray(pointRecord.out_Source) ? pointRecord.out_Source[0] : null;
  return sourceEdge && sourceEdge.in && sourceEdge.in['@rid'] ? sourceEdge.in['@rid'] : null;
}

function buildPathLabel(resourceRecord, pointName) {
  var breadcrumbs = resourceRecord && Array.isArray(resourceRecord.breadcrumbs) ? resourceRecord.breadcrumbs : [];
  var pathSegments = breadcrumbs
    .map(function (breadcrumb) { return breadcrumb && breadcrumb.name; })
    .filter(function (name) { return name; });

  if (pointName) {
    pathSegments.push(pointName);
  }

  if (pathSegments.length) {
    return pathSegments.join(' > ');
  }

  if (resourceRecord && typeof resourceRecord.path === 'string') {
    return resourceRecord.path;
  }

  return pointName;
}

function applyAssetDisplayPath(assetRecord, resourceRecord) {
  var pointName = getPointName(assetRecord);
  assetRecord.pointName = pointName;
  assetRecord.breadcrumbs = resourceRecord && Array.isArray(resourceRecord.breadcrumbs) ? resourceRecord.breadcrumbs : [];
  assetRecord.path = buildPathLabel(resourceRecord, pointName) || getPointRid(assetRecord);
}

function applyResourcePathsToAssets(assets, resourceRequests, resourceResults) {
  var resourcesByRid = {};
  var useOrderedFallback = resourceResults.length === resourceRequests.length;

  resourceResults.forEach(function (resourceRecord) {
    if (resourceRecord && resourceRecord['@rid']) {
      resourcesByRid[resourceRecord['@rid']] = resourceRecord;
    }
  });

  resourceRequests.forEach(function (request, idx) {
    var assetRecord = assets[request.assetIndex];
    var resourceRecord = resourcesByRid[request.rid] || (useOrderedFallback ? resourceResults[idx] : null);
    if (assetRecord && resourceRecord) {
      applyAssetDisplayPath(assetRecord, resourceRecord);
    }
  });
}

component.oninit = function () {
  var ctrl = this;
  document.title = 'nimrod | Calibrations';
  header.vm.activeTab('Calibrations');

  ctrl.pointSortModeLast = prop(false);
  ctrl.pointSortModeNext = prop(false);
  ctrl.newNode = prop(false);
  ctrl.selectedGroups = prop([]);

  loaders.requestWithLoader({
    url: '/api/v1/group/',
    method: 'GET',
  })
  .then(function (groups)  {
    ctrl.groups = groups.map(function (group, idx) {
      return {key: group.name, value: group['@rid']}
    })
  });  

  ctrl.assetsToShow = [];

  ctrl.loadAssets = function (params) {
    return loaders.requestWithLoader({
      url: "/api/v1/asset",
      method: "GET",
      params: params
    })
    .then(function(data){
      ctrl.assets = data.filter(r => !r.deleted);
      var resourceRequests = [];

      ctrl.assets.forEach(function(record, idx){
        applyAssetDisplayPath(record);
        var sourceRid = getPointSourceRid(record);
        if (sourceRid) {
          resourceRequests.push({assetIndex: idx, rid: sourceRid});
        }
      });

      if (!resourceRequests.length) {
        return [];
      }
  
      return loaders.requestWithLoader({
        url: "/api/v1/audit/resources",
        method: "POST",
        body: resourceRequests.map(function (request) { return request.rid; }),
      })
      .then(function (result) {
        applyResourcePathsToAssets(ctrl.assets, resourceRequests, result || []);
      });
    })
    .then(function () {
      ctrl.sortPointsByLastCalibration();
      ctrl.newNode(true);
    });
  };

  ctrl.getAssetsByGroup = function () {
    return ctrl.loadAssets({
      groups: ctrl.selectedGroups().map(element => element.replace(/'/g, ''))
    });
  }

  ctrl.sortPointsByLastCalibration = function () {
    ctrl.pointSortModeLast(!ctrl.pointSortModeLast());
    if (ctrl.pointSortModeLast()) {
      ctrl.assets.sort((a, b) => {
        const lastActionA = a.lastAction ? a.lastAction : Number.MAX_SAFE_INTEGER;
        const lastActionB = b.lastAction ? b.lastAction : Number.MAX_SAFE_INTEGER;
        return lastActionA - lastActionB;
      });
    } else {
      ctrl.assets.sort((a, b) => {
        const lastActionA = a.lastAction ? a.lastAction : Number.MIN_SAFE_INTEGER;
        const lastActionB = b.lastAction ? b.lastAction : Number.MIN_SAFE_INTEGER;
        return lastActionB - lastActionA;
      });
    }
    ctrl.newNode(true);
  }
  ctrl.sortPointsByNextCalibration = function () {
    ctrl.pointSortModeNext(!ctrl.pointSortModeNext());
    if (ctrl.pointSortModeNext()) {
      ctrl.assets.sort((a, b) => {
        const lastActionA = a.lastAction ? a.lastAction : Number.MAX_SAFE_INTEGER;
        const lastActionB = b.lastAction ? b.lastAction : Number.MAX_SAFE_INTEGER;
        return lastActionA - lastActionB;
      });
    } else {
      ctrl.assets.sort((a, b) => {
        const lastActionA = a.lastAction ? a.lastAction : Number.MIN_SAFE_INTEGER;
        const lastActionB = b.lastAction ? b.lastAction : Number.MIN_SAFE_INTEGER;
        return lastActionB - lastActionA;
      });
    }
    ctrl.newNode(true);
  }

  ctrl.closeCalibration = function (record) {
    if (record.lastAction) {
      var today = new Date()
      var nextCalibration = new Date(record.lastAction).setFullYear(new Date(record.lastAction).getFullYear() + 1) 
      var difference = Math.round((nextCalibration - today) / (7 * 24 * 60 * 60 * 1000))
      if (difference<=2) {
        return m('td.tl.red', moment(new Date(record.lastAction).setFullYear(new Date(record.lastAction).getFullYear() + 1)).format(dateFormat))
      } else {
        return m('td.tl', moment(new Date(record.lastAction).setFullYear(new Date(record.lastAction).getFullYear() + 1)).format(dateFormat))
      }
    } else {
      return m('td.tl', "Pending")
    }
  }

  ctrl.getAllCertificates = function () {
    var filteredRids = calibrationBulkReport.getVisibleCalibrationAssetIds(ctrl.assetsToShow);

    if (!filteredRids.length) {
      alerts.vm.add({detail: 'No calibration records selected.'});
      m.redraw();
      return;
    }

    downloadReportModalInterface.editDialogue({
      modalTitle: `Download Certificates on This Page`, 
      reportName: `CalibrationCertificates-Page`,
      assetsIds: filteredRids
    })
  }

  ctrl.loadAssets();
}

component.view = function () {
  var ctrl = this

  if (!ctrl.assets || !ctrl.groups) {
    return m('div')
  }
  return m('div.pb5.pb0-l', [
    m('div.mh3',[
      m(heading,{label:'Calibrations', class:'f-subheadline mb3 pb1 display'}),
      m(paginationWithSearch, {
        data: ctrl.assets,
        newNode: ctrl.newNode,
        dataToShow: ctrl.assetsToShow,
        placeHolder: 'Search',
        itemsPerPage: 30,
        fieldsToSearch: ['path', 'pointName'],
        secondFilterDOM: session.user().isSuperuser == 1 ? 
            m(groupsFilterComponent, {
              filterGroupsModal,
              groups: ctrl.groups,
              selectedGroups: ctrl.selectedGroups,
              getAssetsByGroup: ctrl.getAssetsByGroup
            }) 
          : ''
      },[
        m('div.overflow-hidden',[
          m('div.dragscroll-container', [
            m('div.dragscroll', {oncreate:dragscroll}, [
              m('table.w-100.f4.mb4.pt3', [
                m('thead', [
                  m('tr', [
                    m('th.ph0.tl', 'Points'),
                    m('th.ph0.tl', { onclick: ctrl.sortPointsByLastCalibration }, [
                      'Last Calibration',
                      !ctrl.pointSortModeLast() ? m('i.ion-ios-arrow-down.ml2') : m('i.ion-ios-arrow-up.ml2')
                    ]),
                    m('th.ph0.tl', { onclick: ctrl.sortPointsByNextCalibration }, [
                      'Next Calibration',
                      !ctrl.pointSortModeNext() ? m('i.ion-ios-arrow-down.ml2') : m('i.ion-ios-arrow-up.ml2')
                    ]),
                    m('th.ph0.tl.ph2', 'Edit'),
                    m('th.ph0.tl.ph2', 'Get Certificate')
                  ])
                ]),
                m('tbody', [
                  ctrl.assetsToShow.map(function (record) {
                    if (!record.out_pointOf) {
                      return m('tr', [
                        m('td.tl.pv0.nowrap',[
                          m('label',{style:{'visibility':'hidden'}}, 'No Data')
                        ]),
                        m('td.tl.pv0.nowrap'),
                        m('td.tl.pv0.nowrap'),
                        m('td.tl.pv0.nowrap'),
                        m('td.tl.pv0.nowrap')
                      ])
                    } else {
                      return m('tr', [
                        m('td.tl.nowrap', [
                          record.out_pointOf[0] ?
                            m(m.route.Link,{
                              class:'blue',
                              href: '/point/' + record.out_pointOf[0].in['@rid'].slice(1)
                            },[
                              record.path
                            ])
                            // (function () {
                            //   if(record.breadcrumbs){
                            //     return record.breadcrumbs.map(function(e){return e.name}).join(' > ') + ' > ' +record.pointName
                            //   }
                            // })()
  
                            
                        :
                          '',
                        ]),
                        m('td.tl', 
                          (function () {
                            if (record.lastAction) {
                              return moment(new Date(record.lastAction)).format(dateFormat)
                            } else {
                              return "Never"
                            }
                          })()
                        ),
                        ctrl.closeCalibration(record),
                        m('td', [
                          m('i.f2.ml2.ion-ios-compose.blue',  {
                            onclick: record.out_pointOf[0] ? function () {
                              m.route.set('/point/' + record.out_pointOf[0].in['@rid'].slice(1), {
                                pointconfigtab: 'Calibration'
                              });
                            } : '',
                          })
                        ]),
                        m('td', [
                          record.lastAction ? 
                            m('i.ml2.ion-ios-cloud-download.blue', {
                              style:{marginRight:'1em'}, 
                              onclick: function () {
                                downloadCalibrationReport(record['@rid']);
                              }
                            })
                          : ''
                        ])
                      ])
                    }
                  })
                ])
              ])
            ])
          ])
        ])
      ]),
      (function () {
        if (calibrationBulkReport.hasVisibleCalibrationAssets(ctrl.assetsToShow)) {
          return m(buttonElement,{
            label:'Get Certificates on This Page',
            class: 'mb2 fr',
            func: ctrl.getAllCertificates
          })
        }
      })()
    ])
  ])
 }

 module.exports = component;
